<template>
  <div class="crewHome">
    <div class="crewHome-content">
      <el-form :inline="true" :model="formInline" class="other-form-left">
        <el-form-item label="船舶:" style="margin-left: 10px">
          <el-input
            v-model="formInline.shipName"
            style="width: 100px"
            :readonly="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="月份:">
          <el-input
            v-model="formInline.month"
            style="width: 100px"
            :readonly="true"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-form :inline="true" :model="formInline" class="other-form-inline">
        <el-form-item v-if="excellType == '2'">
          <div class="other-check" @click="chooseCrew()">选择船员</div>
        </el-form-item>
        <el-form-item>
          <div class="other-search3" @click="exportExcel">导出</div>
        </el-form-item>
      </el-form>
      <div style="clear: both"></div>
      <el-divider class="other-divider"></el-divider>
      <div class="other-table-energy">
        <el-table
          :data="tableData"
          style="width: 100%"
          header-row-class-name="other-header"
          row-class-name="other-row"
          height="100%"
        >
          <el-table-column prop="userName" label="船员姓名" min-width="100">
          </el-table-column>
          <el-table-column prop="postName" label="职务" min-width="100">
          </el-table-column>
          <el-table-column prop="crewType" label="船员类型" min-width="80">
            <template slot-scope="scope">
              <span>{{
                scope.row.crewType == 1
                  ? "自有船员"
                  : scope.row.crewType == 2
                  ? "外包船员"
                  : ""
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="ratio" label="系数" min-width="120">
          </el-table-column>
          <el-table-column prop="reward" label="基数" min-width="100">
          </el-table-column>
          <el-table-column
            prop="safetyGroupTotal"
            label="发放金额"
            min-width="100"
          >
            <template slot-scope="scope">
              <div v-if="excellType == 2">
                <el-input
                  v-model="scope.row.safetyGroupTotal"
                  type="number"
                  size="mini"
                  placeholder="请输入"
                ></el-input>
              </div>
              <div v-if="excellType == 1">
                {{ scope.row.safetyGroupTotal }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            min-width="100"
            v-if="excellType == '2'"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                class="other-watch"
                @click="delCrew(scope.$index)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="energy-footer" v-if="excellType == '2'">
        <div class="energy-button1" @click="goback()">返回</div>
        <div class="energy-button2" @click="excellSubmit()">核准</div>
      </div>
    </div>
    <addCrew ref="addCrew" @choseShip="choseShip"></addCrew>
  </div>
</template>
<script>
import {
  getSpecialSafetyGroupUserList,
  safetyGroupUpdateOrApprove,
  getSpecialSafetyGroupShipDetail,
} from "@/apis/index";
import { apiJob } from "@/config";
import addCrew from "./addCrew";
export default {
  data() {
    return {
      formInline: {},
      tableData: [],
      tableData2: [],
      labelVal: "管理费(10%)",
      currentPage1: 1,
      pageNo: "1",
      total: 0,
      pageSize: 100,
      companyVisible: false,
      jobParams: {},
      remendLoading: false,
      diaList: {},
      rules: {
        userState: [
          {
            required: true,
            message: "请选择员工在本派遣机构状态",
            trigger: "blur",
          },
        ],
      },
      excellType: "",
    };
  },
  components: {
    addCrew,
  },
  mounted() {
    this.excellType = this.$route.params.type;
    this.getCrewInfoList();
    this.getSpecialEnergySavingShipDetail();
  },
  methods: {
    delCrew(index) {
      this.tableData.splice(index, 1);
    },
    chooseCrew() {
      let list = this.tableData.filter((val) => {
        return val.shipId.indexOf("、") < 0;
      });
      let shipId = this.formInline.shipId;
      this.$refs.addCrew.showToggle(list, shipId);
    },
    choseShip(val) {
      // let newTabel = [];
      val.forEach((item) => {
        this.tableData.forEach((el) => {
          if (item.userId == el.userId && item.postName == el.postName) {
            item.ratio = el.ratio;
            item.outsourcingTotal = el.outsourcingTotal;
            item.safetyGroupTotal = el.safetyGroupTotal;
            item.reward = el.reward;
            item.ownerTotal = el.ownerTotal;
          }
        });
      });
      val.forEach((item) => {
        if (!item.reward) {
          this.$set(item, "reward", this.formInline.reward);
        }
        if (!item.safetyGroupTotal) {
          this.$set(item, "safetyGroupTotal", 0);
        }
        if (!item.outsourcingTotal) {
          this.$set(item, "outsourcingTotal", 0);
        }
        if (!item.ownerTotal) {
          this.$set(item, "ownerTotal", 0);
        }
        if (!item.ratio) {
          this.$set(item, "ratio", 0);
        }
        if (!item.procInstId) {
          this.$set(item, "procInstId", this.formInline.procInstId);
        }
      });
      this.tableData = val;
      console.log(this.tableData);
    },
    onSubmit() {
      this.pageNo = 1;
      this.getCrewInfoList();
    },
    handleOpen() {},
    handleSizeChange(val) {
      this.pageSize = val;
      this.getCrewInfoList();
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getCrewInfoList();
      // console.log(`当前页: ${val}`);
    },
    choseCom() {
      this.companyVisible = true;
    },
    async getCrewInfoList() {
      let res = await getSpecialSafetyGroupUserList({
        specialSafetyGroupShipId: this.$route.params.id,
        pageSize: this.pageSize,
        pageNo: this.pageNo,
      });
      this.total = res.data.rowCount;
      this.tableData = res.data.resultList;
      this.tableData.forEach((item) => {
        if (item.inviteTime) {
          item.inviteTime = item.inviteTime.split(" ")[0];
        }
      });
    },
    async getSpecialEnergySavingShipDetail() {
      let res = await getSpecialSafetyGroupShipDetail({
        safetyGroupShipId: this.$route.params.id,
      });
      this.formInline = res.data || {};
      // console.log(res);
    },

    excellSubmit() {
      this.$confirm("确定核准吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 执行删除操作
          // this.$message({
          //   message: "核准成功",
          //   type: "success",
          // });
          this.delList();
          // console.log(scope);
        })
        .catch(() => {});
    },
    async delList() {
      let totlaPirze = 0;
      this.tableData.forEach((item) => {
        if (item.safetyGroupTotal) {
          totlaPirze += item.safetyGroupTotal * 1;
        }
      });
      if (totlaPirze != this.formInline.reward) {
        this.$message.warning("发放金额总和应等于基数");
        return;
      }
      this.formInline.ismSalarySpecialSafetyGroupUserDOS = this.tableData;
      this.formInline.approveState = "1";
      let res = await safetyGroupUpdateOrApprove(this.formInline);
      if (res.code > 0) {
        this.$message({
          message: "核准成功",
          type: "success",
        });
        this.getCrewInfoList();
        this.excellType = "1";
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
      // console.log(res);
      // this.getCrewInfoList();
    },
    passInvite(scope) {
      this.jobParams = {};
      this.diaList = scope.row;
      this.companyVisible = true;
    },
    rememendCrewPass() {
      if (!this.jobParams.userState) {
        this.$message({
          message: "请选择是否属于本公司",
          type: "error",
        });
        return;
      }
      this.remendLoading = true;
      this.addCrewList();
    },
    goback() {
      this.$router.go(-1);
    },
    exportExcel() {
      window.open(
        `${apiJob}/exportSpecialSafetyGroupUserList/exportExcel?token=${sessionStorage.getItem(
          "agenToken"
        )}&specialSafetyGroupShipId=${this.$route.params.id || ""}`
      );
    },
  },
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 0.5em;
  height: 0.5em;
}

/* 隐藏滚动条轨道 */
::-webkit-scrollbar-track {
  background-color: transparent;
}

/* 隐藏滚动条滑块 */
::-webkit-scrollbar-thumb {
  background-color: transparent;
}
</style>
